<template>
  <el-form ref="academicConsultantJudgment" :inline="false" :model="academicConsultantJudgment"
    label-width="160px">
  <div v-if="daysLeftEvaluate">
    <!-- <el-form-item label="Εισήγηση Εισηγητή:">
      <span v-html="proponentProposal"></span>
    </el-form-item>
    <el-form-item label="Σχόλιο Εισηγητή:">
      {{ proponentComment }}
    </el-form-item> -->
    <el-form-item label="Ημερ. ανάθεσης:">
      {{ this.application.applicationHistory[this.application.applicationHistory.length - 1].date.substring(0, 10) }}
      <el-alert type="warning" :title="daysLeftEvaluate +' μέρες απομένουν για να υποβληθεί η αξιολόγηση.'" show-icon :closable="false"></el-alert>
      </el-form-item>
    </div>
    <el-form-item v-if="application.grade_description" label="Βαθμός">
      {{ application.grade }}
    </el-form-item>
    <el-form-item v-if="application.grade_description" label="Χαρακτηρισμός">
      {{ application.grade_description }}
    </el-form-item>
    <!-- Μόνο όταν η αίτηση έχει περάσει από επιτροπή και έρχεται στο σύμβουλο για αναθεώρηση μαθημάτων -->
    <!-- <div v-if="this.application.applicationHistory.slice(0).reverse()
        .find(step => step.applicationStatus === 'proponentW_Board')">
      <el-form-item label="Επιτροπή:">
        <el-table :data="boardJudgement" style="width: 100%">
          <el-table-column label="Όνομα"  width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.firstname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Επώνυμο"  width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.surname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Αποδοχή πρότασης" align="center">
            <el-table-column label="Εισηγητή"  width="90" align="center">
              <template slot-scope="scope">
                <span class="agree-btn" v-if="scope.row.agreeWithProponent === true"> <i class="el-icon-check"></i></span>
                <span class="disagree-btn" v-if="scope.row.agreeWithProponent === false"> <i class="el-icon-close"></i></span>
              </template>
            </el-table-column>
            <el-table-column label="Ακαδημαικού Συμβούλου"  width="110" v-if='fromConsultant' align="center">
              <template slot-scope="scope">
                <span class="agree-btn" v-if="scope.row.agreeWithAC === true"> <i class="el-icon-check"></i></span>
                <span class="disagree-btn" v-if="scope.row.agreeWithAC === false"> <i class="el-icon-close"></i></span>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="Εισήγηση">
            <template slot-scope="scope">
              <span>{{ scope.row.proposal }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Υποβολή"  width="85" align="center">
            <template slot-scope="scope">
              <span class="done-btn" v-if="scope.row.finalize === true"> <i class="el-icon-check"></i></span>
              <span class="pending-btn" v-if="scope.row.finalize === false"> <i class="el-icon-edit"></i></span>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </div> -->
    <div>
      <proposals></proposals>
      <internalComments></internalComments>
    <br>
    <el-form-item label="Εσωτερικό Σχόλιο:">
      <el-input type="textarea" class="commentText" placeholder="Εισάγετε εσωτερικό σχόλιο"
        v-model="academicConsultantJudgment.internalComment" size="100"
        :autosize="{ minRows: 4, maxRows: 10 }" @change="modifyInternalComment">
      </el-input>
    </el-form-item>
    <el-form-item label="Εισήγηση:">
      <el-input type="textarea" class="commentText" placeholder="Εισάγετε την εισήγησή σας εδώ"
      v-model="academicConsultantJudgment.proposal" @change="modifyProposal" size="100" :autosize="{ minRows: 4, maxRows: 10}">
      </el-input>
    </el-form-item>
    </div>
    <div style="text-align: center">
      <el-button size="mini" type="primary" round @click="tempSave()">Αποθήκευση</el-button>
      <el-button size="mini" type="danger"  round @click="finalSave()" :disabled="!isValidForm">Ολοκλήρωση</el-button>
    </div>
  </el-form>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import internalComments from '../common/internalComments'
import Proposals from '../common/Proposals'
import sharedMethods from '../common/sharedMethods.js'

export default {
  mixins: [sharedMethods],
  props: ['application'],
  components: {
    internalComments,
    Proposals
  },
  data () {
    return {
      modified: false
    }
  },
  methods: {
    tempSave () {
      axios.put(`${this.BASE_URL}/academicconsultants/uid/applications/${this.workingApplication.id}/temp`,
        {
          judgment: {
            proposal: this.academicConsultantJudgment.proposal,
            internalComment: this.academicConsultantJudgment.internalComment
          }
        }
      ).then((response) => {
        this.frontEndSuccessMsg('Τα δεδομένα αποθηκεύτηκαν με επιτυχία')
      }).catch(err => {
        this.frontEndError('Σφάλμα κατά την προσωρινή αποθήκευση')
        this.catchError(err)
      })
    },
    finalSave () {
      this.$confirm('Η αίτηση προωθείται στον Πρόεδρο. Θέλετε να προχωρήσετε;',
        'Προειδοποίηση', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Άκυρο',
          type: 'warning'
        }).then(() => {
        axios.put(`${this.BASE_URL}/academicconsultants/uid/applications/${this.workingApplication.id}/final`,
          {
            judgment: {
              proposal: this.academicConsultantJudgment.proposal
                ? this.academicConsultantJudgment.proposal : '',
              internalComment: this.academicConsultantJudgment.internalComment
                ? this.academicConsultantJudgment.internalComment : ''
            }
          }
        ).then((response) => {
          // this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', 'consultantw_proponent')
          this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', this.activeLane)
          this.frontEndSuccessMsg('Η αίτηση προωθήθηκε με επιτυχία')
        }).catch(err => {
          this.frontEndError('Σφάλμα κατά την οριστική αποθήκευση')
          this.catchError(err)
        })
      })
    },
    modifyInternalComment (val) {
      this.modified = !(this.academicConsultantJudgment.internalComment === this.internalComment)
    },
    modifyProposal (val) {
      this.modified = !(this.academicConsultantJudgment.proposal === this.proposal)
    },
    catchError (err) {
      this.backendError(err)
      throw err
    }
  },
  computed: {
    // ημέρες που απομένουν για να υποβληθεί η αξιολόγηση πριν το πέρασμα των 15 ημερών
    daysLeftEvaluate () {
      const lastState = this.application.applicationHistory[this.application.applicationHistory.length - 1]
      if (lastState.applicationStatus === 'consultantW_President') {
        let dateAssigned = lastState.date
        let dateNow = new Date()
        if (dateAssigned !== null) {
          dateAssigned = new Date(dateAssigned.replace(/-/g, '/'))
          const ONE_DAY = 1000 * 60 * 60 * 24
          const differenceMs = Math.abs(dateNow - dateAssigned)
          return 15 - Math.round(differenceMs / ONE_DAY)
        }
      }
    },
    isValidForm: function () {
      if (this.academicConsultantJudgment.proposal === null || this.academicConsultantJudgment.proposal.trim() === '') {
        return false
      }
      return true
    },
    fromConsultant () {
      return this.workingApplication.applicationHistory.slice().reverse().find(item => item.applicationStatus === 'boardW_Consultant') !== undefined
    },
    academicConsultantJudgment () {
      return this.application.applicationHistory.slice(0).reverse()
        .find(step => step.applicationStatus === 'consultantW_President').judgment
      // return this.application.applicationHistory.slice(0).reverse()
      //   .find(step => step.applicationStatus === 'consultantW_Proponent').judgment
    },
    proponentProposal () {
      return this.application.applicationHistory.slice(0).reverse()
        .find(step => step.applicationStatus === 'proponentW_President' || step.applicationStatus === 'proponentW_Board').judgment.proposal
    },
    proponentComment () {
      return this.application.applicationHistory.slice(0).reverse()
        .find(step => step.applicationStatus === 'proponentW_Board' || step.applicationStatus === 'proponentW_President').judgment.internalComment
    },
    boardJudgement () {
      return this.application.applicationHistory.slice(0).reverse()
        .find(step => step.applicationStatus === 'boardW_Proponent' || step.applicationStatus === 'boardW_President' || step.applicationStatus === 'boardW_Consultant').judgment
    },
    ...mapState([
      'workingApplication',
      'activeLane',
      'BASE_URL'
    ])
  }
}
</script>
<style lang="scss">
.commentText {
  width: 700px;
}
.agree-btn {
    background-color: #67c23a;
    border-radius: 20px;
    color: #fff;
    display: inline-block;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
}
.disagree-btn {
    background-color: red;
    border-radius: 20px;
    color: #fff;
    display: inline-block;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
}
.done-btn {
    background-color: #67c23a;
    border-radius: 20px;
    color: #fff;
    display: inline-block;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
}
.pending-btn {
    background-color: orange;
    border-radius: 20px;
    color: #fff;
    display: inline-block;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
}
.el-checkbox__label {
  background-color: transparent;
}
.el-form-item {
  // color: rgb(30, 0, 128);
  // font-weight: bold;
  /* border-radius: 10px;
  border-style: solid;
  border-color: #7fa3bb green #86b8da yellow;
  border-width: 0px 0px 2px 0px; */
  padding-right: 20px;
}
hr {
  border-color: #7da0b8;
}
.el-alert {
  width: 350px;
  font-style: normal;
  text-align:left;
  display: inline;
  margin-left: 10px;
}
.text-red {
  font-style:normal;
  color:crimson;
}

.el-form-item__content {
  line-height: 20px;
}
.el-form-item__label {
    text-align: right;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.el-form-item {
  color: rgb(30, 0, 128);
  font-weight: bold;
  // border-radius: 10px;
  // border-style: solid;
  // border-color: #7fa3bb green #86b8da yellow;
  // border-width: 0px 0px 2px 0px;
  // border: 2px 0px 0px 0px solid #7fa3bb;
  padding-right: 20px;
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/roleSpecific/AcademicConsultantJudgment.vue